import {useResultPageStore} from "../stores/ResultPageStore";
import Analytics from "../util/Analytics";

class OutputSelectionManager {

    listener = false;

    constructor() {
    }

    toggleOutput(job, output) {
        Analytics.send('result_action', 'select_toggle', job);

        this.store = useResultPageStore();
        let storeJob = this.store.getJobById(job.id);

        if (storeJob.selectedOutputs.includes(output.id)) {
            let index = storeJob.selectedOutputs.indexOf(output.id);
            storeJob.selectedOutputs.splice(index, 1);
            return;
        }

        storeJob.selectedOutputs.push(output.id);
    }

    isOutputSelected(job, output) {
        this.store = useResultPageStore();
        let storeJob = this.store.getJobById(job.id);

        return storeJob.selectedOutputs.includes(output.id);
    }

    selectAll(job) {
        this.store = useResultPageStore();

        let storeJob = this.store.getJobById(job.id);

        this.deselectAll(job);

        storeJob.apiJob.output.forEach((output) => {
            storeJob.selectedOutputs.push(output.id);
        })
    }

    deselectAll(job) {
        this.store = useResultPageStore();
        let storeJob = this.store.getJobById(job.id);

        while (storeJob.selectedOutputs.length > 0) {
            storeJob.selectedOutputs.pop();
        }
    }

    getSelected(job) {
        this.store = useResultPageStore();
        let storeJob = this.store.getJobById(job.id);
        return storeJob.selectedOutputs;
    }
    
    getAllOutputs(job) {
        this.store = useResultPageStore();
        let storeJob = this.store.getJobById(job.id);
        return storeJob.apiJob.output
    }

    getSelectedOutputs(job) {
        this.store = useResultPageStore();
        let storeJob = this.store.getJobById(job.id);

        let selectedOutputs = this.getSelected(job);

        let outputs = [];

        storeJob.apiJob.output.forEach((output) => {
            if (selectedOutputs.includes(output.id)) {
                outputs.push(output);
            }
        })

        return outputs;
    }

    getSelectedUrls(job) {
        this.store = useResultPageStore();
        let selected = this.getSelected(job);
        let urls = [];

        selected.forEach((selectedOutput) => {
            let output =  this.store.getOutputById(job.id, selectedOutput);
            urls.push({url: output.uri});
        });

        return urls;
    }
}

export default new OutputSelectionManager()